export enum OrderDocumentStatus {
  Confirmation = 'Confirmation',
  Invoice = 'Invoice',
  None = 'None',
  PackingSlip = 'PackingSlip',
  PickingList = 'PickingList',
}
